<template>
  <div id="inspectionForm">
    <v-row no-gutters justify="start">
      <v-col cols="12">
        <v-card v-if="loadItem" class="pa-3">
          <v-card-text>
            <v-progress-linear v-if="loadItem" color="primary" indeterminate/>
            <p v-if="loadItem" class="text-center">{{$t('general.loading')}}</p>
          </v-card-text>
        </v-card>
        <v-card v-else class="pa-2">
          <v-card-title>
            <h4>#{{editedItem.consecutive_number}} - "{{editedItem.name}}"</h4>
            <v-spacer></v-spacer>
            <v-btn @click="openViewOperator" color="primary" class="ml-2">
              {{ $t('general.view') }}  {{ $t('general.operat') }}
              <v-icon small class="ml-2">mdi-eye-outline</v-icon>
            </v-btn>
            <v-btn @click="downloadPdf" :loading="loadReport" color="primary" class="ml-2">
              {{$t('tests.download')}}
              <v-icon small class="ml-2">fas fa-cloud-download-alt</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="my-2">
            <v-row no-gutters>
              <v-col cols="2">
                <h3 class="mb-4"><span class="primary--text">{{$t('general.user')}}: </span>{{editedItem.user.name}} </h3>
              </v-col>
              <v-col cols="3">
                <h3 class="mb-4"><span class="primary--text">{{$t('general.duration')}}: </span>{{editedItem.duration}} </h3>
              </v-col>
              <v-col cols="3">
                <h3 class="mb-4"><span class="primary--text">{{$t('general.site')}}: </span>{{editedItem.site.name}} </h3>
              </v-col>
              <v-col cols="2">
                <h3 class="mb-4">
                  <span class="primary--text">{{ $t('inspections.transit') }}: </span>
                    {{ editedItem.transit ? $t(`inspections.${editedItem.transit.toLowerCase()}`) : 'N/A' }}
                  </h3>
              </v-col>
              <v-col cols="2">
                <h3 class="mb-4"><span class="primary--text">{{$t('general.created')}}: </span>{{editedItem.created_at}} </h3>
              </v-col>
              <v-col cols="12">
                <v-card outlined class="pa-4">
                  <v-row dense>
                    <template v-for="(section, index) in editedItem.sections">
                      <!-- Columna del contenido -->
                      <v-col v-if="section.unit !== null" :key="'section-' + index" cols="3">
                        <h3 class="primary--text mb-4 text-uppercase text-center">{{$t('general.dataOfThe')}} {{ section.unit.unit_types.alias }}</h3>
                        <v-row dense no-gutters>
                          <v-col cols="6">
                            <h4 class="mb-2"><span class="primary--text">VIN: </span>{{section.unit.vin_number}}</h4>
                            <h4 class="mb-2"><span class="primary--text">{{ $t('inspections.type') }}: </span>{{ section.unit.unit_types.alias  }}</h4>
                            <h4 class="mb-2"><span class="primary--text">{{ $t('general.unitNumber') }}: </span>{{ section.unit.unit_number  }}</h4>
                            <h4 class="mb-2">
                              <span class="primary--text">{{ $t('general.plates') }}: </span>
                              <span v-if="section.unit === null || section.unit.plates.length === 0">{{$t('units.noPlates')}}</span>
                              <span v-else>
                                <v-chip small v-for="plate in section.unit.plates" :key="plate.id" class="mx-1 pr-0 mb-2" color="secondary">
                                  {{plate.plate_number}} <v-chip small class="ml-1" color="primary">{{plate.country["alpha_code-3"]}}</v-chip>
                                </v-chip>
                              </span>
                            </h4>
                            <!-- REALIZADO ASI SOLO POR DISEÑO -->
                            <div v-for="(dataAdditional, indexCol1) in section.add_data" :key="dataAdditional.id">
                              <h4 v-if="indexCol1 <= 3" class="mb-2"><span class="primary--text">{{ dataAdditional.field }}</span>: {{ dataAdditional.value === null ? 'N/A' : convertText(dataAdditional.value) }}</h4>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div v-for="(dataAdditional, indexCol2) in section.add_data" :key="dataAdditional.id">
                              <h4 v-if="indexCol2 > 3" class="mb-2"><span class="primary--text">{{ dataAdditional.field }}</span>: {{ dataAdditional.value === null ? 'N/A' : convertText(dataAdditional.value) }}</h4>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <!-- Columna del divisor -->
                      <v-col v-if="index < editedItem.sections.length - 1 && section.unit !== null" :key="'divider-' + index" cols="1" class="text-center">
                        <v-divider vertical />
                      </v-col>
                    </template>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12"> - </v-col>
            </v-row>
            <v-divider class="my-5"/>
            <v-row class="mb-5" no-gutters align="center" justify="center">
              <v-col>
                <h3>{{$t('tests.sections')}}:</h3>
              </v-col>
              <v-col class="text-right">
                <v-btn depressed v-if="panels.length === 0" @click="openPanels">
                  {{$t('general.openAll')}}
                </v-btn>
                <v-btn depressed v-else @click="closePanels">
                  {{$t('general.closeAll')}}
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-expansion-panels v-model="panels" multiple accordion hover>
                  <v-expansion-panel v-for="(section, index) in editedItem.sections" :key="index">
                    <v-expansion-panel-header>
                      <v-row align="center" no-gutters>
                        <v-col cols="6">
                          <h4>{{index + 1}}.- "{{section.name}}"</h4>
                        </v-col>

                        <!-- Solo mostrar Estatus y Motivo de Rechazo si la empresa tiene el ID 20 -->
                        <template v-if="userLoggedCompanies() === 20 || userLoggedCompanies() === 21">
                          <v-col cols="3">
                            <h4 class="text-uppercase">
                              {{$t('general.status')}}:
                              <v-chip
                                small
                                :color="getSectionStatusColor(section)"
                                class="white--text"
                                outlined
                              >
                                {{ getSectionStatusText(section) }}
                              </v-chip>
                            </h4>
                          </v-col>
                          <v-col cols="3">
                            <h4 class="font-weight-bold">
                              <span class="text-uppercase">{{$t('general.reasonRejection')}}:</span>
                              <span style="margin-left: 1px;">
                                {{ section.comment ? section.comment : 'N/A' }}
                              </span>
                            </h4>
                          </v-col>
                        </template>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content color="grey lighten-5">
                      <v-row>
                        <v-col cols="12">
                          <h4>{{$t('general.description')}}:</h4>
                          <p>{{section.description}}</p>
                        </v-col>
                        <v-col class="pt-0" col="12">
                          <h4>{{$t('tests.questions')}}:</h4>
                        </v-col>
                        <v-col v-for="(question, index2) in section.questions" :key="index2" class="pt-0" cols="12">
                          <v-card>
                            <v-card-text>
                              <v-row no-gutters align="center" justify="center">
                                <v-col cols="1">
                                  <h3>{{index2 + 1}}.-</h3>
                                </v-col>
                                <v-col cols="9">
                                  <h4>{{question.description}}
                                    <span class="ma-0 error--text">{{ question.is_critical === 1 ? ' *' : ''}}</span>
                                    <v-icon small color="error" v-if="question.attach_required === 1">mdi-paperclip</v-icon>
                                  </h4>
                                  <span>
                                    <v-radio-group hide-details v-model="question.answer" row readonly label="R:">
                                      <v-radio
                                        v-for="option in filteredRadioOptions"
                                        :disabled="question.answer !== option.value"
                                        :key="option.id"
                                        :label="option.label"
                                        :value="option.value"
                                      />
                                    </v-radio-group>
                                  </span>
                                </v-col>
                                <v-col cols="2" class="text-end">
                                <span v-for="(level, i) in levels" :key="i">
                                  <v-chip
                                    :color="level.value === question.damage_level ? level.color : ''"
                                    class="mr-3 white--text"
                                    v-if="(level.value === question.damage_level && question.damage_level !== 'NONE') && (question.answer === 0 || question.files.length > 0)"
                                  >
                                    {{$t(level.text)}}
                                  </v-chip>
                                </span>
                                <div style="position: relative; display: inline-block;">
                                  <!-- Icono de imagen con el chip arriba a la derecha -->
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon
                                        v-on="on"
                                        class="mr-3"
                                        v-if="question.files && question.files[0]"
                                        @click="viewImage(question)"
                                      >
                                        far fa-image
                                      </v-icon>
                                    </template>
                                    <span>{{$t('inspections.viewImg')}}</span>
                                  </v-tooltip>

                                  <!-- Chip indicando el total de imágenes -->
                                  <v-chip
                                    v-if="question.files && question.files.length > 0"
                                    color="red"
                                    class="white--text"
                                    style="position: absolute; top: -9px; right: -9px; font-size: 11px; height: 15px; min-width: 10px; padding: 0 8px;"
                                    small
                                  >
                                    {{ question.files.length }}
                                  </v-chip>
                                </div>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-on="on"
                                      v-if="question.comment !== ''"
                                      @click="viewComment(question.comment)"
                                    >
                                      far fa-comment
                                    </v-icon>
                                  </template>
                                  <span>{{$t('inspections.viewCom')}}</span>
                                </v-tooltip>
                              </v-col>
                              </v-row>
                              <v-row v-if="hasTireDetails(question)" no-gutters>
                                <v-col offset="1" cols="10">
                                  <v-divider class="my-3" />
                                  <div class="d-flex align-center flex-wrap">
                                    <span class="tire-details-title mr-4">
                                      <v-icon x-small color="primary" class="mr-1">mdi-circle</v-icon>
                                      {{$t('inspections.tireDetails')}}
                                    </span>
                                    <v-chip
                                      v-for="field in tireDetailFields"
                                      v-show="question.tire_details[field.key]"
                                      :key="field.key"
                                      small
                                      outlined
                                      color="primary"
                                      class="tire-details-chip mr-2 my-1"
                                    >
                                      <strong class="mr-1">{{$t(field.label)}}:</strong>
                                      {{ question.tire_details[field.key] }}
                                    </v-chip>
                                  </div>
                                  <small class="grey--text">{{$t('inspections.tireDetailsReadOnly')}}</small>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" depressed @click="redirect">{{$t('general.return')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog scrollable v-model="imageDialog" width="600px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="primary--text">{{ isImage ? $t('general.image') : $t('general.comment') }}</h3>
          <v-spacer />
          <!-- Contador de imágenes -->
          <div v-if="isImage && viewItem.files">
            <span class="primary--text">{{ currentImageIndex + 1 }}/{{ viewItem.files.length }}</span>
          </div>
        </v-toolbar>
        <v-card-text v-if="isImage">
          <template v-if="viewItem.files && viewItem.files.length > 1">
            <v-carousel hide-delimiters @change="updateCurrentImageIndex">
              <v-carousel-item v-for="(file, index) in viewItem.files" :key="index">
                <v-img :src="file.public_url" />
              </v-carousel-item>
            </v-carousel>
          </template>
          <template v-else-if="viewItem.files && viewItem.files.length === 1">
            <v-img :src="viewItem.files[0].public_url" />
          </template>

          <span v-for="(level, i) in levels" :key="i">
            <v-chip
              small
              :color="level.value === damage ? level.color : ''"
              class="mr-3 mt-3 white--text"
              v-if="level.value === damage && damage !== 'NONE'"
            >
              {{ $t(level.text) }}
            </v-chip>
          </span>
          <div v-if="comment !== '' || null">
            <h4 class="mt-2">{{ $t('general.comment') }}:</h4>
            <p>{{ comment }}</p>
          </div>
        </v-card-text>
        <v-card-text v-else>
          <h4>{{ $t('general.comment') }}:</h4>
          <p>{{ viewItem }}</p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" depressed @click="close">{{ $t('general.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogViewOperator" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="primary--text">{{ $t('general.operat') }} </span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form lazy-validation ref="form">
            <v-row dense>
              <v-col cols="6">
                <v-text-field v-model="formData.name" :label="$t('general.name')" outlined dense readonly/>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="formData.last_name" :label="$t('general.lastNames')" outlined dense readonly/>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="formData.vigenteLicense" :label="$t('general.vigenteLicense')" outlined dense prepend-icon="event" readonly/>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="formData.credential_number" :label="$t('general.credentialNumber')" outlined dense readonly/>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="formData.license_number" :label="$t('general.numberLicense')" outlined dense readonly/>
              </v-col>
              <v-col cols="6" style="padding-bottom: 30px;">
                <span>{{$t('general.credential')}}</span>
                <v-radio-group v-model="formData.credential_validate" hide-details="auto" disabled class="mt-1" row>
                  <v-radio :label="$t('general.doesNotComply')" :value="0" class="mt-0" color="primary"/>
                  <v-radio :label="$t('general.pass')" :value="1" class="mt-0" color="primary"/>
                  </v-radio-group>
              </v-col>
              <v-col cols="6" style="padding-bottom: 30px;">
                <span>{{$t('general.licence')}}</span>
                  <v-radio-group v-model="formData.license_validate"  hide-details="auto" disabled class="mt-1" row>
                    <v-radio :label="$t('general.doesNotComply')" :value="0" class="mt-0" color="primary"/>
                    <v-radio :label="$t('general.pass')" :value="1" class="mt-0" color="primary"/>
                  </v-radio-group>
              </v-col>
              <v-col cols="4">
                <small class="grey--text">{{ $t('general.photoCredential') }}</small>
                <v-img :src="formData.photoCredentialView" max-height="200" max-width="250" contain/>
              </v-col>
              <v-col cols="4">
                <small class="grey--text">{{ $t('general.photoLicense') }}</small>
                <v-img :src="formData.photoLicenseView" max-height="200" max-width="250" contain />
              </v-col>
              <v-col cols="4">
                <small class="grey--text">{{ $t('general.photoOperator') }}</small>
                <v-img :src="formData.photoUserView" max-height="200" max-width="250" contain/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn @click="dialogViewOperator = false" class="float-right mr-2" color="primary" outlined>
                  {{$t('general.close')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'inspectionForm',
  data () {
    return {
      imageDialog: false,
      loadItem: true,
      loadReport: false,
      isImage: false,
      panels: [],
      tireDetailFields: [
        { key: 'brand', label: 'general.brand' },
        { key: 'model', label: 'general.model' },
        { key: 'folio', label: 'inspections.folio' }
      ],
      viewItem: '',
      currentImageIndex: 0,
      damage: '',
      comment: '',
      editedItem: {},
      levels: this.$constants.DAMAGE_LEVEL,
      dialogViewOperator: false,
      operatorValidate: {},
      formData: {
        name: '',
        last_name: '',
        vigenteLicense: '',
        credential_number: '',
        license_number: '',
        photoCredentialView: {},
        photoLicenseView: {},
        photoUserView: {},
        credential_validate: null,
        license_validate: null,
      },
    }
  },
  watch: {
    editedItem() {
      if (this.editedItem && this.editedItem.sections) {
        this.$store.dispatch('inspections/getOperatorValidate', {event: {id: this.editedItem.id, context: this}})
      }
    },
    operatorValidate() {
      if (this.operatorValidate && this.operatorValidate.length > 0) {
        this.formData.name = this.operatorValidate[0].name
        this.formData.last_name = this.operatorValidate[0].last_name
        this.formData.vigenteLicense = this.operatorValidate[0].license_expiration ? this.operatorValidate[0].license_expiration : ''

        this.formData.credential_number = this.operatorValidate[0].credential_number
        this.formData.license_number = this.operatorValidate[0].licence_number

        this.formData.credential_validate = this.operatorValidate[0].inspections_with_pivot[0].pivot.credential_verification
        this.formData.license_validate = this.operatorValidate[0].inspections_with_pivot[0].pivot.license_verification

        this.formData.photoCredentialView = this.operatorValidate[0].credential ? this.operatorValidate[0].credential.public_url : {}
        this.formData.photoLicenseView = this.operatorValidate[0].licence ? this.operatorValidate[0].licence.public_url : {}
        this.formData.photoUserView = this.operatorValidate[0].photo_file ? this.operatorValidate[0].photo_file.public_url : {}
      }
    }
  },
  computed: {
    filteredRadioOptions() {
      return this.radioOptions.filter(option => {
        //Se quito la compañia con el id=21
        // return !(option.value === 2 && (this.userLoggedCompanies() !== 20 && this.userLoggedCompanies() !== 21));
        return !(option.value === 2 && (this.userLoggedCompanies() !== 20));
      });
    },
    radioOptions () {
      return [
        {id: 1, label: 'OK', value: 1},
        {id: 2, label: this.$t('general.fail'), value: 0},
        {id: 3, label: 'N/A', value: 3},
        {id: 4, label: this.$t('general.pollution'), value: 2},
      ]
    }
  },
  created () {
    if (this.$route.params.id) {
      this.$store.dispatch('inspections/getById', {event: {id: this.$route.params.id, context: this}})
    }
  },
  methods: {
    openViewOperator() {
      this.dialogViewOperator = true
    },
    convertText(value) {
      if(value === '0' || value === "1") {
        return value === '1' ? this.$t('general.yes') : this.$t('general.no')
      }

      if (typeof value === 'string') {
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      }
      return value;
    },
    userLoggedCompanies() {
      if (this.$store.state.userLogged && this.$store.state.userLogged.companies && this.$store.state.userLogged.companies.length > 0) {
        return this.$store.state.userLogged.companies[0].id;
      } else {
        return null;
      }
    },
    downloadPdf () {
      this.loadReport = true
      this.$store.dispatch('inspections/getPdf', {
        event: {
          context: this,
          id: this.$route.params.id
        }
      })
    },
    viewImage (question) {
      this.isImage = true
      this.viewItem = { files: question.files };
      this.comment = question.issues_notes
      this.damage = question.damage_level
      this.imageDialog = true
    },
    openPanels () {
      this.panels = [...Array(this.editedItem.sections.length).keys()].map((k, i) => i)
    },
    closePanels () {
      this.panels = []
    },
    viewComment (comment) {
      this.isImage = false
      this.viewItem = comment
      this.imageDialog = true
    },
    close () {
      this.imageDialog = false
      this.viewItem = ''
      this.comment = ''
    },
    redirect () {
      if (this.$route.name === 'viewHistory') {
        this.$router.push('/history')
      } else if (this.$route.name === 'viewInspection') {
        this.$router.push('/inspections')
      } else if (this.$route.name === 'reportViewInspection') {
        this.$router.push('/reports/inspectionUnitTypes')
      } else if (this.$route.name === 'reportCountByUnitViewInspection') {
        this.$router.push('/reports/inspectionCountByUnit')
      } else if (this.$route.name === 'reportTireChangeViewInspection') {
        this.$router.push('/reports/tireChangeReport')
      }
    },
        // Método para determinar el color del v-chip basado en el estatus y las respuestas
    getSectionStatusColor(section) {
      if (section.status === 0 && this.areAllAnswersNull(section.questions)) {
        return 'grey';
      }
      return section.status === 0 ? 'green' : 'red';
    },

    // Método para determinar el texto del v-chip basado en el estatus y las respuestas
    getSectionStatusText(section) {
      if (section.status === 0 && this.areAllAnswersNull(section.questions)) {
        return 'N/A';
      }
      return section.status === 0 ? this.$t('general.approved') : this.$t('general.refused');
    },

    // Método para verificar si todas las respuestas en una sección son null
    areAllAnswersNull(questions) {
      return questions.every(question => question.answer === null || question.answer === 'N/A');
    },
    updateCurrentImageIndex(index) {
      this.currentImageIndex = index; // Actualiza el índice cuando cambia la imagen
    },
    // Verifica si la pregunta trae datos de llanta con al menos un valor
    hasTireDetails(question) {
      const details = question.tire_details
      return !!details && this.tireDetailFields.some(field => details[field.key])
    }
  }
}
</script>

<style scoped>
.tire-details-title {
  font-size: 13px;
  font-weight: 600;
}
.tire-details-chip {
  background-color: #f5f8ff !important;
  color: #424242 !important;
}
</style>